import React from 'react';
import PropTypes from 'prop-types';
import NachaMessage from "../NachaMessage";
import PendingAchInput from "components/payments/paymentInputs/PendingAchInput";
import { paymentInputDefaultProps, paymentInputPropTypes, paymentTypes } from './PaymentSelector';
import PaymentProfileOptions from "components/payments/detailInputs/PaymentProfileOptions";
import ConvenienceFeeCheckbox from 'components/payments/paymentInputs/ConvenienceFeeCheckbox';
import StripeBankDebitVerify from './StripeBankDebitVerify';
import { usesIntents } from '../stripe/stripeUtils';

export default class PaymentProfileInput extends React.Component {
  static propTypes = {
    ...paymentInputPropTypes,
    buttonText: PropTypes.func,
    submittingText: PropTypes.func,
    onSubmit: PropTypes.func,

    paymentProfile: PropTypes.object
  };

  static defaultProps = {
    ...paymentInputDefaultProps,
    buttonText: () => 'Submit Payment',
    submittingText: () => 'Submitting Payment...'
  };

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      convenienceFeeAccepted: false,
      error: null,
    };
  }

  componentDidMount() {
    const {
      billingConfig,
      paymentProfile
    } = this.props;

    this.setState({ autopay: paymentProfile.autopay_enabled });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { paymentProfile } = this.props;

    if (paymentProfile.id !== prevProps.paymentProfile.id) {
      this.setState({ autopay: paymentProfile.autopay_enabled });
    }
  }

  handleSubmit(){
    this.setState({
      submitting: true,
      error: null,
    });

    return this.props.beforeSubmit()
      .then(() => this.props.onSubmit({
        paymentDetails: this.props.paymentProfile,
        autopay: this.state.autopay,
        savePaymentProfile: true,
        payment_method: "payment profile",
        token: this.props.paymentProfile.id
      }))
      .then(this.props.afterSubmit)
      .catch(this.handleError.bind(this))
      .then(()=>this.setState({
        submitting: false
      }));
  }

  handleError(error) {
    const message = error.message || 'There was an error processing your payment. Please try again.';
    this.setState({
      error: message,
      submitting: false,
    });
  }

  convenienceFeeConfirmationRequired(){
    const {
      customer: {
        payment_config: {
          payment_methods: {
            [this.props.paymentProfile.payment_method]: {
              convenience_fee: {
                show_confirmation_message = false
              } = {}
            } = {}
          } = {}
        } = {}
      },
      convenienceFee
    } = this.props;

    return show_confirmation_message && (convenienceFee != 0);
  }

  render() {
    const { amount, billingConfig, customer, paymentProfile, showAutopayOption } = this.props;
    const {
      submitting,
      autopay,
      convenienceFeeAccepted,
      error,
    } = this.state;
    const valid = convenienceFeeAccepted || !this.convenienceFeeConfirmationRequired();
    const disabled = this.props.disabled || !valid || submitting;

    const buttonText = this.props.buttonText(customer, paymentProfile.payment_method);
    const submittingText = this.props.submittingText(customer, paymentProfile.payment_method);

    const paymentVerification = paymentProfile.payment_verification;
    const requiresVerification = !!paymentVerification && paymentVerification.status !== 'verified';

    if (requiresVerification) {
      return usesIntents(customer)
        ? <StripeBankDebitVerify {...this.props} />
        : <PendingAchInput {...this.props} />;
    }

    return <div>
      {error && <div className={'alert alert-danger'}>{error}</div>}

      {this.convenienceFeeConfirmationRequired() && (
        <ConvenienceFeeCheckbox
          customer={customer}
          checked={convenienceFeeAccepted}
          paymentMethod={this.props.paymentProfile.payment_method}
          onChange={(...params) => {
            this.setState({ convenienceFeeAccepted: !this.state.convenienceFeeAccepted });
          }}
          disabled={submitting}
        />
      )}

      {!!showAutopayOption && <PaymentProfileOptions
        billingConfig={billingConfig}
        customer={customer}
        showSaveProfileOption={false}
        showAutopayOption={showAutopayOption}
        savePaymentProfile={true}
        paymentMethod={this.props.paymentProfile.payment_method}
        autopay={autopay}
        onChange={(props) => this.setState(props)}
        disabled={submitting}
      />}

      <button className={'btn btn-primary col-24 submit-payment-profile'}
              onClick={this.handleSubmit.bind(this)}
              disabled={disabled}
      >
        {submitting ? submittingText : buttonText}
      </button>

      <NachaMessage amount={amount}
                    buttonText={buttonText}
                    customer={customer}/>
    </div>;
  }
}
